module.exports = __webpack_public_path__ + "img/Toptal-Rackpost_small.3b8a9028.png";